/** @format */

import {useSearchParams} from 'helpers/routerHelpers';

import {SensorCategoriesBunchType, SensorCategoriesCriteriaType, SensorCategoriesType} from 'types';

import {CategoryBunch} from './CategoryBunch';
import {CategoryCriteria} from './CategoryCriteria';

function isCriteriaType(value: SensorCategoriesType): value is SensorCategoriesCriteriaType {
  return value === 'critical' || value === 'normal' || value === 'low';
}

function isBunchType(value: SensorCategoriesType): value is SensorCategoriesBunchType {
  return (
    value === 'budget' ||
    value === 'feeds' ||
    value === 'targeting_semantic_kernel' ||
    value === 'campaign_settings' ||
    value === 'ads_quality' ||
    value === 'kpi'
  );
}

const CategoryNew = () => {
  const searchParams = useSearchParams();
  const categoryName = searchParams.get('name') as SensorCategoriesType;

  if (isCriteriaType(categoryName)) {
    return <CategoryCriteria categoryName={categoryName} />;
  }

  if (isBunchType(categoryName)) {
    return <CategoryBunch categoryName={categoryName} />;
  }

  return null;
};

export default CategoryNew;
